export function onlyNumerics(value: string): string {
  return value.replace(/\D/g, '')
}

export function sanitizePhone(value: string): string {
  return `+55${onlyNumerics(value.replace('+55', ''))}`
}
